import BookView from './book-view-page'

function BookViewPage() {
  return (
    <BookView/>
  )
}

export default BookViewPage;
